/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Label, Alert, Button, InputGroup,
  NavItem, NavLink, Nav, TabPane, TabContent,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { post, get } from '../../helpers/api_helper';

function EncompassMapper(props) {
  const {
    onAccept,
    search,
    t,
  } = props;

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      try {
        const response = await get(`/api/map/encompass?q=${encodeURIComponent(search)}`);
        // eslint-disable-next-line no-console
        console.log(response);

        const d = { ...response };
        const set = new Set(d.images.slice(0, 3));
        d.images = [...set];

        setData(d);
      } catch (error) {
        toastr.error(t('Error'), error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [search]);

  const jsx = (
    <>
      <h5>{t('EncompassParts.com')}</h5>

      {loading && (
        <span className="fs-6">
          <i className="fa fa-spinner fa-spin" />
          {' '}
          {t('Searching')}
        </span>
      )}

      {!loading && data !== null && (
        <>
          <div>
            <strong>{t('Brand')}</strong>
            :
            {' '}
            {data.brand || 'N/A'}
          </div>

          {data.attributes.map((x) => (
            <div key={x.key}>
              <strong>{x.key}</strong>
              :
              {' '}
              {x.value}
            </div>
          ))}

          <div>
            <strong>{t('Title')}</strong>
            :
            {' '}
            <a href={data.source} target="_blank" rel="noreferrer">{data.name || 'N/A'}</a>
          </div>

          <div>
            <strong>{t('Dims')}</strong>
            :
            {' '}
            {data.dimensions || 'N/A'}
          </div>

          <div>
            {data.images.map((x, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <span key={`img_${i}`}>
                {x.path.includes('.jpg') && (
                  <img src={x.path} alt="" style={{ maxWidth: '55px', maxHeight: '64px' }} />
                )}
              </span>
            ))}
          </div>

          <Button
            color="primary"
            size="sm"
            onClick={async (e) => {
              const d = {};

              const old = e.target.innerHTML;
              e.target.disabled = true;
              e.target.innerHTML = '<i class="fa fa-spinner fa-spin" />';

              const pn = data.attributes.find((x) => x.key === 'Part Number');
              if (pn) {
                d.part_number = pn.value;
              }

              d.images = data.images.map((x) => x.path).filter((x) => x.includes('.jpg'));
              d.manufacturer = data.brand;
              d.customs_description = data.name;
              d.value_usd = data.retail;
              d.dimensions = data.dimensions;

              const models = data.models.map((x) => ({ brand: data.brand, model: x }));

              try {
                const devices = await Promise.all(
                  models.map((model) => get(`/api/devices/find?brand=${encodeURIComponent(model.brand)}&model=${encodeURIComponent(model.model)}&create=1`)),
                );

                d.devices = devices.filter((dev) => dev !== null);
              } catch (error) {
                toastr.error(t('Error'), error.message);
              }

              e.target.disabled = false;
              e.target.innerHTML = old;

              onAccept(d);
            }}
          >
            {t('Accept')}
          </Button>
        </>
      )}
    </>
  );

  return jsx;
}

EncompassMapper.defaultProps = {
  onAccept: () => {},
};

EncompassMapper.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  search: PropTypes.object.isRequired,
  onAccept: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(EncompassMapper));
